export default function Question({children}) {

    return (
        <p className="test__question">
            {children}
        </p>
    );
}